<div [class.row]="!showInOneRow">
  <div [ngClass]="!showInOneRow ? 'col-auto d-flex justify-content-start p-0' : ''"
       *ngFor="let itemName of alertToBeShown">

    <div *ngIf="usingSwitch || notificationForm.get(itemName).value?.enabled"
         class="p-0 m-2 bg-secondary border rounded"
         [ngStyle]="!showInOneRow ? {'width': cardDefaultWidth} : ''">
      <container-element [ngSwitch]="itemName"
                         class="p-0">
        <ng-container *ngSwitchCase="rmmAlertTypes.HighCpuUsage"
                      [ngTemplateOutlet]="HighCpuUsage"></ng-container>
        <ng-container *ngSwitchCase="rmmAlertTypes.HighMemoryUsage"
                      [ngTemplateOutlet]="HighMemoryUsage"></ng-container>
        <ng-container *ngSwitchCase="rmmAlertTypes.LowDiskSpace"
                      [ngTemplateOutlet]="LowDiskSpace"></ng-container>
        <ng-container *ngSwitchCase="rmmAlertTypes.SmartNotHealthy"
                      [ngTemplateOutlet]="SmartNotHealthy"></ng-container>
        <ng-container *ngSwitchCase="rmmAlertTypes.SoftwareChanges"
                      [ngTemplateOutlet]="SoftwareChanges"></ng-container>
        <ng-container *ngSwitchCase="rmmAlertTypes.HardwareChanges"
                      [ngTemplateOutlet]="HardwareChanges"></ng-container>
        <ng-container *ngSwitchCase="rmmAlertTypes.ConnectionLoss"
                      [ngTemplateOutlet]="ConnectionLoss"></ng-container>
        <ng-container *ngSwitchCase="rmmAlertTypes.NoAntivirus"
                      [ngTemplateOutlet]="NoAntivirus"></ng-container>
        <ng-container *ngSwitchCase="rmmAlertTypes.NotUpdated"
                      [ngTemplateOutlet]="NotUpdated"></ng-container>
        <ng-container *ngSwitchCase="rmmAlertTypes.SnmpDevice"
                      [ngTemplateOutlet]="SnmpDevice"></ng-container>
        <ng-container *ngSwitchCase="rmmAlertTypes.ServiceState"
                      [ngTemplateOutlet]="ServiceState"></ng-container>
        <ng-container *ngSwitchCase="rmmAlertTypes.HighTemperature"
                      [ngTemplateOutlet]="HighTemperature"></ng-container>
        <ng-container *ngSwitchCase="rmmAlertTypes.WrongSystemTime"
                      [ngTemplateOutlet]="WrongSystemTime"></ng-container>
        <ng-container *ngSwitchDefault></ng-container>
      </container-element>
    </div>
  </div>
</div>

<!-- ACTION TEMPLATES -->
<ng-template #HighCpuUsage>
  <form [formGroup]="notificationForm">
    <div [formGroupName]="rmmAlertTypes.HighCpuUsage">

      <div class="m-3">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="fw-bold mb-0">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.steps.highCpuUsage' | i18next }}
            </h4>
          </div>
          <ng-container [ngTemplateOutlet]="usingSwitch ? showSwitch : removeButton">
            <ng-template #showSwitch>
              <div class="col-auto">
                <mbs-switcher formControlName="enabled"
                              [disabledSelf]="disableSettingChanges">
                </mbs-switcher>
              </div>
            </ng-template>
            <ng-template #removeButton>
              <div class="col-auto mr-2">
                <mbs-button icon="fa text-md fa-trash"
                            (click)="disableAlert(rmmAlertTypes.HighCpuUsage)">
                </mbs-button>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <hr>

      <div class="m-3">
        <div class="row">
          <div class="col-4">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.alertPercent' | i18next: { value: ' (%)' }"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
          <div class="col-4">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.duration' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <mbs-number formControlName="alertPercent"
                        [disabledSelf]="disableSettingChanges"
                        [min]="50"
                        [max]="100">
            </mbs-number>
          </div>
          <div class="col-4">
            <mbs-number formControlName="updateDeferNumber"
                        [disabledSelf]="disableSettingChanges"
                        [min]="notificationForm.get(rmmAlertTypes.HighCpuUsage).get('updateDeferType').value === notifyItems[0] ? 1 : 5"
                        [max]="notificationForm.get(rmmAlertTypes.HighCpuUsage).get('updateDeferType').value === notifyItems[0] ? 48 : 59"
                        [id]="'updateDeferNumber'">
            </mbs-number>
          </div>
          <div class="col-3">
            <mbs-select [appendTo]="'body'"
                        formControlName="updateDeferType"
                        [disabledSelf]="disableSettingChanges"
                        [items]="notifyItems"
                        [clearable]="false"
                        [searchable]="false">
            </mbs-select>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #HighMemoryUsage>
  <form [formGroup]="notificationForm">
    <div [formGroupName]="rmmAlertTypes.HighMemoryUsage">

      <div class="m-3">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="fw-bold mb-0">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.steps.highMemoryUsage' | i18next }}
            </h4>
          </div>
          <ng-container [ngTemplateOutlet]="usingSwitch ? showSwitch : removeButton">
            <ng-template #showSwitch>
              <div class="col-auto">
                <mbs-switcher formControlName="enabled"
                              [disabledSelf]="disableSettingChanges">
                </mbs-switcher>
              </div>
            </ng-template>
            <ng-template #removeButton>
              <div class="col-auto mr-2">
                <mbs-button icon="fa text-md fa-trash"
                            (click)="disableAlert(rmmAlertTypes.HighMemoryUsage)">
                </mbs-button>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <hr>

      <div class="m-3">
        <div class="row">
          <div class="col-4">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.alertPercent' | i18next: { value: ' (%)' }"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
          <div class="col-4">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.duration' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <mbs-number formControlName="alertPercent"
                        [disabledSelf]="disableSettingChanges"
                        [min]="50"
                        [max]="100">
            </mbs-number>
          </div>
          <div class="col-4">
            <mbs-number formControlName="updateDeferNumber"
                        [disabledSelf]="disableSettingChanges"
                        [min]="notificationForm.get(rmmAlertTypes.HighMemoryUsage).get('updateDeferType').value === notifyItems[0] ? 1 : 5"
                        [max]="notificationForm.get(rmmAlertTypes.HighMemoryUsage).get('updateDeferType').value === notifyItems[0] ? 48 : 59"
                        [id]="'updateDeferNumber'">
            </mbs-number>
          </div>
          <div class="col-3">
            <mbs-select [appendTo]="'body'"
                        formControlName="updateDeferType"
                        [disabledSelf]="disableSettingChanges"
                        [items]="notifyItems"
                        [clearable]="false"
                        [searchable]="false">
            </mbs-select>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #LowDiskSpace>
  <form [formGroup]="notificationForm">
    <div [formGroupName]="rmmAlertTypes.LowDiskSpace">

      <div class="m-3">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="fw-bold mb-0">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.steps.lowDiskSpace' | i18next }}
            </h4>
          </div>
          <ng-container [ngTemplateOutlet]="usingSwitch ? showSwitch : removeButton">
            <ng-template #showSwitch>
              <div class="col-auto">
                <mbs-switcher formControlName="enabled"
                              [disabledSelf]="disableSettingChanges">
                </mbs-switcher>
              </div>
            </ng-template>
            <ng-template #removeButton>
              <div class="col-auto mr-2">
                <mbs-button icon="fa text-md fa-trash"
                            (click)="disableAlert(rmmAlertTypes.LowDiskSpace)">
                </mbs-button>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <hr>

      <div class="m-3">
        <div class="row">
          <div class="col-4">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.alertPercent' | i18next: { value: ' (%)' }"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
          <div class="col-4">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.duration' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <mbs-number formControlName="alertPercent"
                        [disabledSelf]="disableSettingChanges"
                        [min]="50"
                        [max]="100">
            </mbs-number>
          </div>
          <div class="col-4">
            <mbs-number formControlName="updateDeferNumber"
                        [disabledSelf]="disableSettingChanges"
                        [min]="notificationForm.get(rmmAlertTypes.LowDiskSpace).get('updateDeferType').value === notifyItems[0] ? 1 : 5"
                        [max]="notificationForm.get(rmmAlertTypes.LowDiskSpace).get('updateDeferType').value === notifyItems[0] ? 48 : 59"
                        [id]="'updateDeferNumber'">
            </mbs-number>
          </div>
          <div class="col-3">
            <mbs-select [appendTo]="'body'"
                        formControlName="updateDeferType"
                        [disabledSelf]="disableSettingChanges"
                        [items]="notifyItems"
                        [clearable]="false"
                        [searchable]="false">
            </mbs-select>
          </div>
        </div>
        <div class="row mt-3">
          <div class="mb-3 col-12">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.excludedVolumeLabels' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
            <mbs-input type="textarea"
                       [disabledSelf]="disableSettingChanges"
                       [placeholder]="'mbs-ui:rmm-custom-alerting.wizard.placeholders.excludedVolumeLabels' | i18next"
                       [rows]="5"
                       formControlName="excludedVolumeLabels">
            </mbs-input>
          </div>
          <div class="mb-3 col-12">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.excludedMountPoints' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
            <mbs-input type="textarea"
                       [disabledSelf]="disableSettingChanges"
                       [placeholder]="'mbs-ui:rmm-custom-alerting.wizard.placeholders.excludedMountPoints' | i18next"
                       [rows]="5"
                       formControlName="excludedMountPoints">
            </mbs-input>
          </div>
        </div>
      </div>
      <div class="m-3">
        <div class="mb-3 d-flex flex-direction-row justify-content-between align-items-center">
          <div>
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.excludeRemovableDisks' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
          <div>
            <mbs-switcher formControlName="excludeRemovableDisks"
                          [disabledSelf]="disableSettingChanges">
            </mbs-switcher>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #NoAntivirus>

  <form [formGroup]="notificationForm">
    <div [formGroupName]="rmmAlertTypes.NoAntivirus">

      <div class="m-3">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="fw-bold mb-0">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.steps.noAntivirus' | i18next }}
            </h4>
          </div>
          <ng-container [ngTemplateOutlet]="usingSwitch ? showSwitch : removeButton">
            <ng-template #showSwitch>
              <div class="col-auto">
                <mbs-switcher formControlName="enabled"
                              [disabledSelf]="disableSettingChanges">
                </mbs-switcher>
              </div>
            </ng-template>
            <ng-template #removeButton>
              <div class="col-auto mr-2">
                <mbs-button icon="fa text-md fa-trash"
                            (click)="disableAlert(rmmAlertTypes.NoAntivirus)">
                </mbs-button>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <hr>

      <div class="m-3">
        <div class="row">
          <div class="col-4">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.duration' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <mbs-number formControlName="updateDeferNumber"
                        [disabledSelf]="disableSettingChanges"
                        [min]="notificationForm.get(rmmAlertTypes.NoAntivirus).get('updateDeferType').value === notifyItems[0] ? 1 : 15"
                        [max]="notificationForm.get(rmmAlertTypes.NoAntivirus).get('updateDeferType').value === notifyItems[0] ? 48: 59"
                        [id]="'updateDeferNumber'">
            </mbs-number>
          </div>
          <div class="col-3">
            <mbs-select [appendTo]="'body'"
                        formControlName="updateDeferType"
                        [disabledSelf]="disableSettingChanges"
                        [items]="notifyItems"
                        [clearable]="false"
                        [searchable]="false">
            </mbs-select>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>


<ng-template #NotUpdated>
  <form [formGroup]="notificationForm">
    <div [formGroupName]="rmmAlertTypes.NotUpdated">

      <div class="m-3">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="fw-bold mb-0">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.steps.notUpdated' | i18next }}
            </h4>
          </div>
          <ng-container [ngTemplateOutlet]="usingSwitch ? showSwitch : removeButton">
            <ng-template #showSwitch>
              <div class="col-auto">
                <mbs-switcher formControlName="enabled"
                              [disabledSelf]="disableSettingChanges">
                </mbs-switcher>
              </div>
            </ng-template>
            <ng-template #removeButton>
              <div class="col-auto mr-2">
                <mbs-button icon="fa text-md fa-trash"
                            (click)="disableAlert(rmmAlertTypes.NotUpdated)">
                </mbs-button>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <hr>

      <div class="m-3">
        <div class="row">
          <div class="col-4">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.duration' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <mbs-number formControlName="updateDeferNumber"
                        [disabledSelf]="disableSettingChanges"
                        [min]="notificationForm.get(rmmAlertTypes.NotUpdated).get('updateDeferType').value === notifyItems[0] ? 1 : 5"
                        [max]="notificationForm.get(rmmAlertTypes.NotUpdated).get('updateDeferType').value === notifyItems[0] ? 48 : 59"
                        [id]="'updateDeferNumber'">
            </mbs-number>
          </div>
          <div class="col-3">
            <mbs-select [appendTo]="'body'"
                        formControlName="updateDeferType"
                        [disabledSelf]="disableSettingChanges"
                        [items]="notifyItems"
                        [clearable]="false"
                        [searchable]="false">
            </mbs-select>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #WrongSystemTime>
  <form [formGroup]="notificationForm">
    <div [formGroupName]="rmmAlertTypes.WrongSystemTime">

      <div class="m-3">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="fw-bold mb-0">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.steps.wrongSystemTime' | i18next }}
            </h4>
          </div>
          <ng-container [ngTemplateOutlet]="usingSwitch ? showSwitch : removeButton">
            <ng-template #showSwitch>
              <div class="col-auto">
                <mbs-switcher formControlName="enabled"
                              [disabledSelf]="disableSettingChanges">
                </mbs-switcher>
              </div>
            </ng-template>
            <ng-template #removeButton>
              <div class="col-auto mr-2">
                <mbs-button icon="fa text-md fa-trash"
                            (click)="disableAlert(rmmAlertTypes.WrongSystemTime)">
                </mbs-button>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <hr>

      <div class="m-3">
        <div class="row">
          <div class="col-4">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.alertWrongSystemTimeDifference' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <mbs-number formControlName="updateDeferNumberDiff"
                        [disabledSelf]="disableSettingChanges"
                        [min]="notificationForm.get(rmmAlertTypes.WrongSystemTime).get('updateDeferTypeDiff').value === notifyItems[0] ? 1 : 5"
                        [max]="notificationForm.get(rmmAlertTypes.WrongSystemTime).get('updateDeferTypeDiff').value === notifyItems[0] ? 48 : 59"
                        [id]="'updateDeferNumber'">
            </mbs-number>
          </div>
          <div class="col-3">
            <mbs-select [appendTo]="'body'"
                        formControlName="updateDeferTypeDiff"
                        [disabledSelf]="disableSettingChanges"
                        [items]="notifyItems"
                        [clearable]="false"
                        [searchable]="false">
            </mbs-select>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #SmartNotHealthy>
  <form [formGroup]="notificationForm">
    <div [formGroupName]="rmmAlertTypes.SmartNotHealthy">

      <div class="m-3">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="fw-bold mb-0">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.steps.smartNotHealthy' | i18next }}
            </h4>
          </div>
          <ng-container [ngTemplateOutlet]="usingSwitch ? showSwitch : removeButton">
            <ng-template #showSwitch>
              <div class="col-auto">
                <mbs-switcher formControlName="enabled"
                              [disabledSelf]="disableSettingChanges">
                </mbs-switcher>
              </div>
            </ng-template>
            <ng-template #removeButton>
              <div class="col-auto mr-2">
                <mbs-button icon="fa text-md fa-trash"
                            (click)="disableAlert(rmmAlertTypes.SmartNotHealthy)">
                </mbs-button>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <hr>

      <div class="m-3">
        <div class="row">
          <div class="col-4">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.duration' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <mbs-number formControlName="updateDeferNumber"
                        [disabledSelf]="disableSettingChanges"
                        [min]="notificationForm.get(rmmAlertTypes.SmartNotHealthy).get('updateDeferType').value === notifyItems[0] ? 1 : 5"
                        [max]="notificationForm.get(rmmAlertTypes.SmartNotHealthy).get('updateDeferType').value === notifyItems[0] ? 48 : 59"
                        [id]="'updateDeferNumber'">
            </mbs-number>
          </div>
          <div class="col-3">
            <mbs-select [appendTo]="'body'"
                        formControlName="updateDeferType"
                        [disabledSelf]="disableSettingChanges"
                        [items]="notifyItems"
                        [clearable]="false"
                        [searchable]="false">
            </mbs-select>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #ConnectionLoss>
  <form [formGroup]="notificationForm">
    <div [formGroupName]="rmmAlertTypes.ConnectionLoss">

      <div class="m-3">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="fw-bold mb-0">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.steps.connectionLoss' | i18next }}
            </h4>
          </div>
          <ng-container [ngTemplateOutlet]="usingSwitch ? showSwitch : removeButton">
            <ng-template #showSwitch>
              <div class="col-auto">
                <mbs-switcher formControlName="enabled"
                              [disabledSelf]="disableSettingChanges">
                </mbs-switcher>
              </div>
            </ng-template>
            <ng-template #removeButton>
              <div class="col-auto mr-2">
                <mbs-button icon="fa text-md fa-trash"
                            (click)="disableAlert(rmmAlertTypes.ConnectionLoss)">
                </mbs-button>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <hr>

      <div class="m-3">
        <div class="mb-3 d-flex flex-direction-row justify-content-between align-items-center">
          <div>
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'shared:notifications.connectionLossForWinServersOnly' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
          <div>
            <mbs-switcher formControlName="notifyToPlatform"
                          [disabledSelf]="disableSettingChanges">
            </mbs-switcher>
          </div>
        </div>
      </div>
      <hr>

      <div class="m-3">
        <div class="mb-3 d-flex flex-direction-row justify-content-between align-items-center">
          <div>
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.notifyOnRestore' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
          <div>
            <mbs-switcher formControlName="notifyOnRestore"
                          [disabledSelf]="disableSettingChanges">
            </mbs-switcher>
          </div>
        </div>
      </div>
      <hr>

      <div class="m-3">
        <div class="row">
          <div class="col-4">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.duration' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <mbs-number formControlName="updateDeferNumber"
                        [disabledSelf]="disableSettingChanges"
                        [min]="notificationForm.get(rmmAlertTypes.ConnectionLoss).get('updateDeferType').value === notifyItems[0] ? 1 : 20"
                        [max]="notificationForm.get(rmmAlertTypes.ConnectionLoss).get('updateDeferType').value === notifyItems[0] ? 48: 59"
                        [id]="'updateDeferNumber'">
            </mbs-number>
          </div>
          <div class="col-3">
            <mbs-select [appendTo]="'body'"
                        formControlName="updateDeferType"
                        [disabledSelf]="disableSettingChanges"
                        [items]="notifyItems"
                        [clearable]="false"
                        [searchable]="false">
            </mbs-select>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #HighTemperature>
  <form [formGroup]="notificationForm">
    <div [formGroupName]="rmmAlertTypes.HighTemperature">

      <div class="m-3">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="fw-bold mb-0">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.steps.highTemperature' | i18next }}
            </h4>
          </div>
          <ng-container [ngTemplateOutlet]="usingSwitch ? showSwitch : removeButton">
            <ng-template #showSwitch>
              <div class="col-auto">
                <mbs-switcher formControlName="enabled"
                              [disabledSelf]="disableSettingChanges">
                </mbs-switcher>
              </div>
            </ng-template>
            <ng-template #removeButton>
              <div class="col-auto mr-2">
                <mbs-button icon="fa text-md fa-trash"
                            (click)="disableAlert(rmmAlertTypes.HighTemperature)">
                </mbs-button>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <hr>

      <div class="m-3">
        <div class="row">
          <div class="col-4">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.alertPercent' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
          <div class="col-4">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.duration' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
          </div>
        </div>
        <div class="row">

          <div class="col-4">
            <mbs-number formControlName="alertHighTemperature"
                        [disabledSelf]="disableSettingChanges"
                        [min]="50"
                        [max]="100">
            </mbs-number>
          </div>
          <div class="col-4">
            <mbs-number formControlName="updateDeferNumber"
                        [disabledSelf]="disableSettingChanges"
                        [min]="notificationForm.get(rmmAlertTypes.HighTemperature).get('updateDeferType').value === notifyItems[0] ? 1 : 5"
                        [max]="notificationForm.get(rmmAlertTypes.HighTemperature).get('updateDeferType').value === notifyItems[0] ? 48 : 59"
                        [id]="'updateDeferNumber'">
            </mbs-number>
          </div>
          <div class="col-3">
            <mbs-select [appendTo]="'body'"
                        formControlName="updateDeferType"
                        [disabledSelf]="disableSettingChanges"
                        [items]="notifyItems"
                        [clearable]="false"
                        [searchable]="false">
            </mbs-select>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #SoftwareChanges>

  <form [formGroup]="notificationForm">
    <div [formGroupName]="rmmAlertTypes.SoftwareChanges">

      <div class="m-3">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="fw-bold mb-0">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.steps.softwareChanges' | i18next }}
            </h4>
          </div>
          <ng-container [ngTemplateOutlet]="usingSwitch ? showSwitch : removeButton">
            <ng-template #showSwitch>
              <div class="col-auto">
                <mbs-switcher formControlName="enabled"
                              [disabledSelf]="disableSettingChanges">
                </mbs-switcher>
              </div>
            </ng-template>
            <ng-template #removeButton>
              <div class="col-auto mr-2">
                <mbs-button icon="fa text-md fa-trash"
                            (click)="disableAlert(rmmAlertTypes.SoftwareChanges)">
                </mbs-button>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <hr>

      <div class="m-3">
        <div [ngClass]="!notificationForm.get(rmmAlertTypes.SoftwareChanges).get('enabled').value ? 'text-muted' : ''">
          <div class="mb-3">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.excludedNames' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
            <mbs-input type="textarea"
                       [disabledSelf]="disableSettingChanges"
                       [placeholder]="'mbs-ui:rmm-custom-alerting.wizard.placeholders.excludedNames' | i18next"
                       [rows]="5"
                       formControlName="excludedNames">
            </mbs-input>
          </div>
          <div class="mb-3">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.excludedVendor' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
            <mbs-input type="textarea"
                       [disabledSelf]="disableSettingChanges"
                       [placeholder]="'mbs-ui:rmm-custom-alerting.wizard.placeholders.excludedVendor' | i18next"
                       [rows]="5"
                       formControlName="excludedVendor">
            </mbs-input>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #HardwareChanges>
  <form [formGroup]="notificationForm">
    <div [formGroupName]="rmmAlertTypes.HardwareChanges">

      <div class="m-3">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="fw-bold mb-0">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.steps.hardwareChanges' | i18next }}
            </h4>
          </div>
          <ng-container [ngTemplateOutlet]="usingSwitch ? showSwitch : removeButton">
            <ng-template #showSwitch>
              <div class="col-auto">
                <mbs-switcher formControlName="enabled"
                              [disabledSelf]="disableSettingChanges">
                </mbs-switcher>
              </div>
            </ng-template>
            <ng-template #removeButton>
              <div class="col-auto mr-2">
                <mbs-button icon="fa text-md fa-trash"
                            (click)="disableAlert(rmmAlertTypes.HardwareChanges)">
                </mbs-button>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <hr>

      <div class="m-3">
        <div [ngClass]="!notificationForm.get(rmmAlertTypes.HardwareChanges).get('enabled').value ? 'text-muted' : ''">
          <div class="mb-3">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.excludedNames' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
            <mbs-input type="textarea"
                       [disabledSelf]="disableSettingChanges"
                       [placeholder]="'mbs-ui:rmm-custom-alerting.wizard.placeholders.excludedNames2' | i18next"
                       [rows]="5"
                       formControlName="excludedNames">
            </mbs-input>
          </div>
          <div class="mb-3">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.excludedPNPClasses' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
            <mbs-input type="textarea"
                       [disabledSelf]="disableSettingChanges"
                       [placeholder]="'mbs-ui:rmm-custom-alerting.wizard.placeholders.excludedPNPClasses' | i18next"
                       [rows]="5"
                       formControlName="excludedPNPClasses">
            </mbs-input>
          </div>
          <div class="mb-3">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.excludedPNPDeviceIDs' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
            <mbs-input type="textarea"
                       [disabledSelf]="disableSettingChanges"
                       [placeholder]="'mbs-ui:rmm-custom-alerting.wizard.placeholders.excludedPNPDeviceIDs' | i18next"
                       [rows]="5"
                       formControlName="excludedPNPDeviceIDs">
            </mbs-input>
          </div>
          <div class="mb-3">
            <mbs-input-label [labelClasses]="'mb-1'"
                             [label]="'mbs-ui:rmm-custom-alerting.wizard.keys.excludedManufacturer' | i18next"
                             [boldLabel]="true">
            </mbs-input-label>
            <mbs-input type="textarea"
                       [disabledSelf]="disableSettingChanges"
                       [placeholder]="'mbs-ui:rmm-custom-alerting.wizard.placeholders.excludedManufacturer' | i18next"
                       [rows]="5"
                       formControlName="excludedManufacturer">
            </mbs-input>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #SnmpDevice>

  <form [formGroup]="notificationForm">
    <div [formGroupName]="rmmAlertTypes.SnmpDevice">

      <div class="m-3">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="fw-bold mb-0">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.steps.snmpDevice' | i18next }}
            </h4>
          </div>
          <ng-container [ngTemplateOutlet]="usingSwitch ? showSwitch : removeButton">
            <ng-template #showSwitch>
              <div class="col-auto">
                <mbs-switcher formControlName="enabled"
                              [disabledSelf]="disableSettingChanges">
                </mbs-switcher>
              </div>
            </ng-template>
            <ng-template #removeButton>
              <div class="col-auto mr-2">
                <mbs-button icon="fa text-md fa-trash"
                            (click)="disableAlert(rmmAlertTypes.SnmpDevice)">
                </mbs-button>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <hr>

      <div class="m-3">
        <mbs-snmp-custom-notifications [enabled]="true"
                                       (selectionChange)="onSnmpSelectionChange($event)">
        </mbs-snmp-custom-notifications>
      </div>
    </div>
  </form>
</ng-template>


<ng-template #ServiceState>

  <form [formGroup]="notificationForm">
    <div [formGroupName]="rmmAlertTypes.ServiceState">

      <div class="m-3">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="fw-bold mb-0">
              {{ 'mbs-ui:rmm-custom-alerting.wizard.steps.serviceState' | i18next }}
            </h4>
          </div>
          <ng-container [ngTemplateOutlet]="usingSwitch ? showSwitch : removeButton">
            <ng-template #showSwitch>
              <div class="col-auto">
                <mbs-switcher formControlName="enabled"
                              [disabledSelf]="disableSettingChanges">
                </mbs-switcher>
              </div>
            </ng-template>
            <ng-template #removeButton>
              <div class="col-auto mr-2">
                <mbs-button icon="fa text-md fa-trash"
                            (click)="disableAlert(rmmAlertTypes.ServiceState)">
                </mbs-button>
              </div>
            </ng-template>
          </ng-container>
        </div>
      </div>
      <hr>

      <div class="m-3">
        <mbs-select-service-modal [enabled]="true"
                                  [disabledSelf]="disableSettingChanges"
                                  [includedServices]="notificationForm.get(rmmAlertTypes.ServiceState).get('includeServices').value ?? []"
                                  (onServiceSelectionChanged)="onServiceSelectionChanged($event)">
        </mbs-select-service-modal>
      </div>
    </div>
  </form>
</ng-template>
